// ABOUTME: The orientation's Schedule a Session button, without any scheduling behaviour
// ABOUTME: FreeBusy binds it by id; the Nylas picker opens from its onClick
import { ArrowRightIcon } from '@execonline-inc/execonline-ui';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../Translations';
import { programCardButtonClassName } from '../../../../Dashboard/ProgramCard';

interface Props {
  buttonId: string;
  disabled: boolean;
  onClick: () => void;
}

const ScheduleButtonView: React.FC<Props> = ({ buttonId, disabled, onClick }) => (
  <button
    className={clsx(
      programCardButtonClassName,
      'm-0 border-0 tracking-normal disabled:cursor-not-allowed disabled:opacity-50',
    )}
    data-test-coaching-orientation-button={'Schedule a Session'}
    data-intercom-target="coaching-orientation-schedule-button"
    id={buttonId}
    disabled={disabled}
    onClick={onClick}
  >
    <T kind={'Schedule a Session'} />
    <ArrowRightIcon size="sm" color="inherit" />
  </button>
);

export default observer(ScheduleButtonView);
